import { useEffect } from "react";
import useGameData from "app/game-data/useGameData";
import { useGameState, useGameActionDispatch } from "app/game/useGame";
import { GameAction } from "app/game/gameState";
import { useScoreDispatch } from "app/score/useScore";
import { ScoreAction } from "app/score/scoreState";
import { clearLocalStorage } from "app/utils/useResetableStorage";

export default function useNewGame() {
  const data = useGameData();
  const { id } = useGameState();
  const gameDispatch = useGameActionDispatch();
  const scoreDispatch = useScoreDispatch();

  useEffect(() => {
    if (data?.id && id !== `${data.id}`) {
      console.info(`New Game! ${data.id}`);
      gameDispatch({
        type: GameAction.NEW_GAME,
        payload: { gameId: `${data.id}` },
      });
      scoreDispatch({
        type: ScoreAction.NEW_GAME,
      });
      clearLocalStorage();
    }
  }, [gameDispatch, data?.id, id]);
}
